const focusFullTarget = () => {
	const blocFocus = document.querySelector('.homepage__focus') || null;
	if (blocFocus) {
		const focusLink = blocFocus.querySelector(
			'.homepage__focus__bloc__link'
		);
		blocFocus.addEventListener('click', () => {
			if (focusLink.getAttribute('target') === '_blank') {
				window.open(focusLink.getAttribute('href'));
			} else {
				window.location(focusLink.getAttribute('href'));
			}
		});
	}
};

const init = () => {
	focusFullTarget();
};

init();
